import { useMemo } from "react";

import EbayLinkButton from "../../shared/Inputs/EbayLinkButton";
import { IPart, IPartCategory } from './../../../models/Part';

export default function UnlistedCategoryRow({ part, categories }: { part: IPart, categories: IPartCategory[] | undefined }) {

  const category = useMemo(() => {
    return categories?.find((cat) => cat.id === part.categoryId);
  }, [part, categories])

  const makeModelString = useMemo(() => {
    let string = "";

    if (part.vehicle?.dvlaYearOfManufacture) {
      string = part.vehicle?.dvlaYearOfManufacture + "+";
    }

    string += part.vehicle?.combinedMake;
    string += "+";
    string += part.vehicle?.modelRangeDescription;

    if (part.category && part.category.name) {
      string += "+";
      string += part.category.name;
    }

    return string;
  }, [part])

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <span>{category?.name ?? part.category?.name ?? "N/A"}</span>
      {category && (
        <EbayLinkButton query={makeModelString} />
      )}
    </div>
  )
}